import { Box } from '@mui/material'
import React from 'react'
import { useDrop } from 'react-dnd'
import { ItemTypes } from '../../utils/dnd/constants'

const Drop = ({ id, onDrop }) => {
  const [{ isOver, isDragging }, dropRef] = useDrop(
    () => ({
      accept: [ItemTypes.LIST_ITEM],
      drop: (item) => {
        onDrop(item, id)
      },
      collect: (monitor) => {
        return {
          isOver: !!monitor.isOver(),
          isDragging:
            !!monitor.getItem() &&
            monitor.getItemType() === ItemTypes.LIST_ITEM,
        }
      },
    }),
    [onDrop]
  )
  return (
    <Box
      ref={dropRef}
      sx={{
        height: isOver ? '148px' : '64px',
        my: -4,

        zIndex: isDragging ? 1 : -1,
        position: 'relative',
        transition: 'all 0.075s',
      }}
    ></Box>
  )
}

export default Drop
